import type { PortfolioView } from "@buildpy/core/views/g4a/portfolio";
import { Link } from "@/lib/nav";

import MetaSep from "@/components/meta-sep";
import SectionCard from "@buildpy/ui/section-card";
import { Button } from "@buildpy/ui/button";
import { formatDateTime } from "@buildpy/core/lib/format";
import ExportZipButton from "@/modules/portfolio/ui/export-zip-button";
import NaverCopyButton from "@/modules/portfolio/ui/naver-copy-button";
import PortfolioForm from "@/modules/portfolio/ui/portfolio-form";
import { CrumbName } from "@/shell/crumb";
import PageHeader from "@/shell/page-header";

/** 시공사례 편집. 등록과 같은 폼을 쓰고 삭제만 여기서 더 낸다. */
const Page = ({ data }: { data: PortfolioView }) => {
  const { portfolio, designers, spaceOptions, projectPhotos, copyBlocked, naver } = data;

  return (
    <>
      <CrumbName name={portfolio.title} />
      <PageHeader
        actions={
          <>
            {portfolio.project_id && (
              <Button asChild size="sm" variant="outline">
                <Link href={`/app/projects/${portfolio.project_id}`}>현장</Link>
              </Button>
            )}
            <Button asChild size="sm" variant="outline">
              <Link href="/app/portfolio">목록</Link>
            </Button>
          </>
        }
        meta={
          <span className="flex flex-wrap items-center gap-x-3 gap-y-1 md:gap-x-2">
            <span>{portfolio.published ? "공개" : "비공개"}</span>
            <MetaSep />
            <span className="whitespace-nowrap">수정 {formatDateTime(portfolio.updated_at)}</span>
          </span>
        }
        title={portfolio.title}
      />

      <SectionCard description="저장한 내용으로 만듭니다 · 공개 페이지에서 숨긴 항목은 빠집니다" title="블로그로 내보내기">
        <div className="flex flex-wrap items-start gap-2">
          <NaverCopyButton
            blockedReason={copyBlocked}
            html={naver?.html ?? null}
            omitted={data.omitted}
            text={naver?.text ?? null}
            warning={data.warning}
          />
          <ExportZipButton portfolioId={portfolio.id} />
        </div>
      </SectionCard>

      <SectionCard as="div" className="lg:p-6">
        <PortfolioForm designers={designers} portfolio={portfolio} projectPhotos={projectPhotos} spaceOptions={spaceOptions} />
      </SectionCard>
    </>
  );
};

export default Page;
